import { Container } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

// contenedor desktop: flex propio para que el 25/75 aplique a los hijos directos
export const VehicleDesktopContainer = styled.div`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: center;
	gap: 24px;
	padding-left: 24px;
`;

// contenedor de texto/CTA: 25% del ancho del padre (desktop)
export const VehicleInfoContainer = styled(Container)`
	text-align: center; // para que también afecte al CTA

	@media (min-width: 960px) {
		flex: 1 1 25%;
		min-width: 0;
	}
`;

// contenedor de la imagen lateral: 75% del ancho del padre en desktop
export const VehicleImageContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex: 1 1 75%;
	min-width: 0;

	img {
		max-width: 100%;
		height: auto;
	}
`;
